import { useAxios } from '@academica-box/composables/axios'
import { VkApi } from '@academica-box/swagger/academgen/api'
import type { CompleteVkGamesTaskRequest } from '@academica-box/swagger/academgen'

export default () => {
  const config = useRuntimeConfig()
  const axios = useAxios()
  const vkApi = new VkApi(undefined, `${config.public.academgenApiUrl}/api`, axios)

  return {
    sendVkGameData(data: CompleteVkGamesTaskRequest) {
      return vkApi.completeVkGamesTask({ completeVkGamesTaskRequest: data })
    }
  }
}
